/* tslint:disable */
/* eslint-disable */
/**
 * API Docs
 * The API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetTreatmentMasterListResponse } from '../model';
// @ts-ignore
import { GetTreatmentMasterListsResponse } from '../model';
// @ts-ignore
import { PostTreatmentMasterListRequest } from '../model';
// @ts-ignore
import { PostTreatmentMasterListResponse } from '../model';
// @ts-ignore
import { PutTreatmentMasterListRequest } from '../model';
// @ts-ignore
import { PutTreatmentMasterListResponse } from '../model';
/**
 * TreatmentMasterListsApi - axios parameter creator
 * @export
 */
export const TreatmentMasterListsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PostTreatmentMasterListRequest} postTreatmentMasterListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTreatment: async (postTreatmentMasterListRequest: PostTreatmentMasterListRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postTreatmentMasterListRequest' is not null or undefined
            assertParamExists('addTreatment', 'postTreatmentMasterListRequest', postTreatmentMasterListRequest)
            const localVarPath = `/api/treatment-master-lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postTreatmentMasterListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTreatment: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTreatment', 'id', id)
            const localVarPath = `/api/treatment-master-lists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTreatmentById', 'id', id)
            const localVarPath = `/api/treatment-master-lists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} namr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentName: async (namr: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'namr' is not null or undefined
            assertParamExists('getTreatmentName', 'namr', namr)
            const localVarPath = `/api/treatment-master-lists/name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (namr !== undefined) {
                localVarQueryParameter['namr'] = namr;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} namr 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentnametype: async (namr: string, type: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'namr' is not null or undefined
            assertParamExists('getTreatmentnametype', 'namr', namr)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getTreatmentnametype', 'type', type)
            const localVarPath = `/api/treatment-master-lists/nametype`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (namr !== undefined) {
                localVarQueryParameter['namr'] = namr;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatments: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/treatment-master-lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} typetreatment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentsByType: async (typetreatment: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'typetreatment' is not null or undefined
            assertParamExists('getTreatmentsByType', 'typetreatment', typetreatment)
            const localVarPath = `/api/treatment-master-lists/type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (typetreatment !== undefined) {
                localVarQueryParameter['typetreatment'] = typetreatment;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostTreatmentMasterListRequest} postTreatmentMasterListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCheckExist: async (postTreatmentMasterListRequest: PostTreatmentMasterListRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postTreatmentMasterListRequest' is not null or undefined
            assertParamExists('postCheckExist', 'postTreatmentMasterListRequest', postTreatmentMasterListRequest)
            const localVarPath = `/api/treatment-master-lists/check-exist-name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postTreatmentMasterListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PutTreatmentMasterListRequest} putTreatmentMasterListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTreatment: async (id: string, putTreatmentMasterListRequest: PutTreatmentMasterListRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTreatment', 'id', id)
            // verify required parameter 'putTreatmentMasterListRequest' is not null or undefined
            assertParamExists('updateTreatment', 'putTreatmentMasterListRequest', putTreatmentMasterListRequest)
            const localVarPath = `/api/treatment-master-lists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putTreatmentMasterListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TreatmentMasterListsApi - functional programming interface
 * @export
 */
export const TreatmentMasterListsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TreatmentMasterListsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {PostTreatmentMasterListRequest} postTreatmentMasterListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTreatment(postTreatmentMasterListRequest: PostTreatmentMasterListRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostTreatmentMasterListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTreatment(postTreatmentMasterListRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTreatment(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutTreatmentMasterListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTreatment(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTreatmentById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreatmentMasterListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTreatmentById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} namr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTreatmentName(namr: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreatmentMasterListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTreatmentName(namr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} namr 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTreatmentnametype(namr: string, type: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreatmentMasterListsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTreatmentnametype(namr, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTreatments(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreatmentMasterListsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTreatments(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} typetreatment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTreatmentsByType(typetreatment: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreatmentMasterListsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTreatmentsByType(typetreatment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostTreatmentMasterListRequest} postTreatmentMasterListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCheckExist(postTreatmentMasterListRequest: PostTreatmentMasterListRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostTreatmentMasterListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCheckExist(postTreatmentMasterListRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {PutTreatmentMasterListRequest} putTreatmentMasterListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTreatment(id: string, putTreatmentMasterListRequest: PutTreatmentMasterListRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutTreatmentMasterListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTreatment(id, putTreatmentMasterListRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TreatmentMasterListsApi - factory interface
 * @export
 */
export const TreatmentMasterListsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TreatmentMasterListsApiFp(configuration)
    return {
        /**
         * 
         * @param {PostTreatmentMasterListRequest} postTreatmentMasterListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTreatment(postTreatmentMasterListRequest: PostTreatmentMasterListRequest, options?: any): AxiosPromise<PostTreatmentMasterListResponse> {
            return localVarFp.addTreatment(postTreatmentMasterListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTreatment(id: string, options?: any): AxiosPromise<PutTreatmentMasterListResponse> {
            return localVarFp.deleteTreatment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentById(id: string, options?: any): AxiosPromise<GetTreatmentMasterListResponse> {
            return localVarFp.getTreatmentById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} namr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentName(namr: string, options?: any): AxiosPromise<GetTreatmentMasterListResponse> {
            return localVarFp.getTreatmentName(namr, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} namr 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentnametype(namr: string, type: string, options?: any): AxiosPromise<GetTreatmentMasterListsResponse> {
            return localVarFp.getTreatmentnametype(namr, type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatments(options?: any): AxiosPromise<GetTreatmentMasterListsResponse> {
            return localVarFp.getTreatments(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} typetreatment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentsByType(typetreatment: string, options?: any): AxiosPromise<GetTreatmentMasterListsResponse> {
            return localVarFp.getTreatmentsByType(typetreatment, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostTreatmentMasterListRequest} postTreatmentMasterListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCheckExist(postTreatmentMasterListRequest: PostTreatmentMasterListRequest, options?: any): AxiosPromise<PostTreatmentMasterListResponse> {
            return localVarFp.postCheckExist(postTreatmentMasterListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {PutTreatmentMasterListRequest} putTreatmentMasterListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTreatment(id: string, putTreatmentMasterListRequest: PutTreatmentMasterListRequest, options?: any): AxiosPromise<PutTreatmentMasterListResponse> {
            return localVarFp.updateTreatment(id, putTreatmentMasterListRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addTreatment operation in TreatmentMasterListsApi.
 * @export
 * @interface TreatmentMasterListsApiAddTreatmentRequest
 */
export interface TreatmentMasterListsApiAddTreatmentRequest {
    /**
     * 
     * @type {PostTreatmentMasterListRequest}
     * @memberof TreatmentMasterListsApiAddTreatment
     */
    readonly postTreatmentMasterListRequest: PostTreatmentMasterListRequest
}

/**
 * Request parameters for deleteTreatment operation in TreatmentMasterListsApi.
 * @export
 * @interface TreatmentMasterListsApiDeleteTreatmentRequest
 */
export interface TreatmentMasterListsApiDeleteTreatmentRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentMasterListsApiDeleteTreatment
     */
    readonly id: string
}

/**
 * Request parameters for getTreatmentById operation in TreatmentMasterListsApi.
 * @export
 * @interface TreatmentMasterListsApiGetTreatmentByIdRequest
 */
export interface TreatmentMasterListsApiGetTreatmentByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentMasterListsApiGetTreatmentById
     */
    readonly id: string
}

/**
 * Request parameters for getTreatmentName operation in TreatmentMasterListsApi.
 * @export
 * @interface TreatmentMasterListsApiGetTreatmentNameRequest
 */
export interface TreatmentMasterListsApiGetTreatmentNameRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentMasterListsApiGetTreatmentName
     */
    readonly namr: string
}

/**
 * Request parameters for getTreatmentnametype operation in TreatmentMasterListsApi.
 * @export
 * @interface TreatmentMasterListsApiGetTreatmentnametypeRequest
 */
export interface TreatmentMasterListsApiGetTreatmentnametypeRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentMasterListsApiGetTreatmentnametype
     */
    readonly namr: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentMasterListsApiGetTreatmentnametype
     */
    readonly type: string
}

/**
 * Request parameters for getTreatmentsByType operation in TreatmentMasterListsApi.
 * @export
 * @interface TreatmentMasterListsApiGetTreatmentsByTypeRequest
 */
export interface TreatmentMasterListsApiGetTreatmentsByTypeRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentMasterListsApiGetTreatmentsByType
     */
    readonly typetreatment: string
}

/**
 * Request parameters for postCheckExist operation in TreatmentMasterListsApi.
 * @export
 * @interface TreatmentMasterListsApiPostCheckExistRequest
 */
export interface TreatmentMasterListsApiPostCheckExistRequest {
    /**
     * 
     * @type {PostTreatmentMasterListRequest}
     * @memberof TreatmentMasterListsApiPostCheckExist
     */
    readonly postTreatmentMasterListRequest: PostTreatmentMasterListRequest
}

/**
 * Request parameters for updateTreatment operation in TreatmentMasterListsApi.
 * @export
 * @interface TreatmentMasterListsApiUpdateTreatmentRequest
 */
export interface TreatmentMasterListsApiUpdateTreatmentRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentMasterListsApiUpdateTreatment
     */
    readonly id: string

    /**
     * 
     * @type {PutTreatmentMasterListRequest}
     * @memberof TreatmentMasterListsApiUpdateTreatment
     */
    readonly putTreatmentMasterListRequest: PutTreatmentMasterListRequest
}

/**
 * TreatmentMasterListsApi - object-oriented interface
 * @export
 * @class TreatmentMasterListsApi
 * @extends {BaseAPI}
 */
export class TreatmentMasterListsApi extends BaseAPI {
    /**
     * 
     * @param {TreatmentMasterListsApiAddTreatmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentMasterListsApi
     */
    public addTreatment(requestParameters: TreatmentMasterListsApiAddTreatmentRequest, options?: AxiosRequestConfig) {
        return TreatmentMasterListsApiFp(this.configuration).addTreatment(requestParameters.postTreatmentMasterListRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentMasterListsApiDeleteTreatmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentMasterListsApi
     */
    public deleteTreatment(requestParameters: TreatmentMasterListsApiDeleteTreatmentRequest, options?: AxiosRequestConfig) {
        return TreatmentMasterListsApiFp(this.configuration).deleteTreatment(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentMasterListsApiGetTreatmentByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentMasterListsApi
     */
    public getTreatmentById(requestParameters: TreatmentMasterListsApiGetTreatmentByIdRequest, options?: AxiosRequestConfig) {
        return TreatmentMasterListsApiFp(this.configuration).getTreatmentById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentMasterListsApiGetTreatmentNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentMasterListsApi
     */
    public getTreatmentName(requestParameters: TreatmentMasterListsApiGetTreatmentNameRequest, options?: AxiosRequestConfig) {
        return TreatmentMasterListsApiFp(this.configuration).getTreatmentName(requestParameters.namr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentMasterListsApiGetTreatmentnametypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentMasterListsApi
     */
    public getTreatmentnametype(requestParameters: TreatmentMasterListsApiGetTreatmentnametypeRequest, options?: AxiosRequestConfig) {
        return TreatmentMasterListsApiFp(this.configuration).getTreatmentnametype(requestParameters.namr, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentMasterListsApi
     */
    public getTreatments(options?: AxiosRequestConfig) {
        return TreatmentMasterListsApiFp(this.configuration).getTreatments(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentMasterListsApiGetTreatmentsByTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentMasterListsApi
     */
    public getTreatmentsByType(requestParameters: TreatmentMasterListsApiGetTreatmentsByTypeRequest, options?: AxiosRequestConfig) {
        return TreatmentMasterListsApiFp(this.configuration).getTreatmentsByType(requestParameters.typetreatment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentMasterListsApiPostCheckExistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentMasterListsApi
     */
    public postCheckExist(requestParameters: TreatmentMasterListsApiPostCheckExistRequest, options?: AxiosRequestConfig) {
        return TreatmentMasterListsApiFp(this.configuration).postCheckExist(requestParameters.postTreatmentMasterListRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentMasterListsApiUpdateTreatmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentMasterListsApi
     */
    public updateTreatment(requestParameters: TreatmentMasterListsApiUpdateTreatmentRequest, options?: AxiosRequestConfig) {
        return TreatmentMasterListsApiFp(this.configuration).updateTreatment(requestParameters.id, requestParameters.putTreatmentMasterListRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
